import Collections from "./Collections";
import "./CollectionsSection.css";

const STATS = [
	{ value: "432 Hz", label: "Mastered audio", color: "#6B9E8D" },
	{ value: "Curated", label: "By practice & mood", color: "#8B7B9D" },
	{ value: "Original", label: "Wellness compositions", color: "#C9A876" },
];

const CollectionsSection = () => (
	<section className="collections-section">
		<p className="collections-lead">
			Handpicked for meditation, focus, sleep, and devotional listening. Press
			play on any cover to preview the sound.
		</p>

		<div className="collections-carousel-wrap">
			<Collections />
		</div>

		<div className="collections-stats">
			{STATS.map((stat) => (
				<div
					key={stat.value}
					className="collections-stat"
					style={{ "--stat-color": stat.color }}
				>
					<span className="collections-stat-dot" />
					<span>
						<span className="collections-stat-value">{stat.value}</span>{" "}
						{stat.label}
					</span>
				</div>
			))}
		</div>
	</section>
);

export default CollectionsSection;
